<template>
  <article
    class="dui-book-synopsis panel panel-overflow no-shadow"
    :class="{ 'collapsed': !vm.isExpanded }"
  >
    <h5 v-if="showTitle">
      Synopsis
    </h5>

    <div class="synopsis-content">
      {{ synopsis }}
    </div>

    <a
      class="toggle"
      @click="toggleExpanded()"
    >
      <span v-if="!vm.isExpanded">
        <span class="button button-black button-sm button-icon button-plus" />
        <span class="valign-middle">Expand synopsis</span>
      </span>
      <span v-if="vm.isExpanded">
        <span class="button button-black button-sm button-icon button-minus" />
        <span class="valign-middle">Collapse synopsis</span>
      </span>
    </a>
  </article>
</template>

<script>
export default {
  props: {
    showTitle: {
      type: Boolean,
      defaut: false,
    },
    synopsis: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    vm: {
      isExpanded: false,
    },
  }),
  methods: {
    toggleExpanded() {
      this.$set(this.vm, 'isExpanded', !this.vm.isExpanded);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-book-synopsis {
  border: $border-width-base dashed getColor($grey, medium);
  overflow: hidden;
  position: relative;

  &:after {
    background-image: linear-gradient(to bottom, $color-translucent-white, getColor($white) 60%);
    bottom: 0;
    content: " ";
    height: (2 * $_10em);
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;
    z-index: 0;

    @include transition((
      opacity
    ), $transition-time-fast);
  }

  &.collapsed {
    max-height: 240px;

    &:after {
      opacity: 1;
    }
  }

  h5 {
    margin-bottom: $_3em;
    text-transform: uppercase;
  }

  .synopsis-content {
    font-family: $alt-font;
    font-size: $font-size-lg;
    font-style: italic;
    padding-bottom: $_5em;
    white-space: pre-line;
  }

  .toggle {
    bottom: $_2em;
    color: getColor($black);
    left: $_2em;
    position: absolute;
    z-index: 1;

    @include screenMoreThan(sm) {
      bottom: $_3em;
      left: $_4em;
    }
  }
}
</style>
